// extracted by mini-css-extract-plugin
export var editButton = "_md-0";